import Vue from 'vue'
import Vuex from 'vuex'
import AuthModule from './modules/auth'
import DealersModule from './modules/dealers'
import AccessRulesModule from './modules/access_rules'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth: AuthModule,
    dealers: DealersModule,
    access_rules: AccessRulesModule
  }
})
